import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "a[rrUiCoreLinkStopPropagation]",
  standalone: true,
})
export class UiCoreLinkStopPropagationDirective {
  @HostListener("click", ["$event"])
  onClick(event: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
